module.exports = __webpack_public_path__ + "img/bloom.1fb1419e.jpg";